
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import { RecipeFoodsData } from "@/types/pantry";
export default defineComponent({
  name: "PantryPRFoodView",
  components: {},
  props: {
    data: {
      type: RecipeFoodsData,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const isShowImage = () => {
      return props.data && props.data.foodItem
    };
    const getImage = () => {
      return props.data && props.data.foodItem && props.data.foodItem.image
        ? props.data.foodItem.image
        : "";
    };
    const getName = () => {
      return props.data && props.data.foodItem && props.data.foodItem.name
        ? props.data.foodItem.name
        : "";
    };
    const getDescription = () => {
      return props.data && props.data.foodItem && props.data.foodItem.description
        ? props.data.foodItem.description
        : "";
    };
    const isShowBanner = () => {
      return (
        props.data &&
        props.data.foodItem &&
        props.data.foodItem.banners &&
        props.data.foodItem.banners.length >= 1);
    };
    const getBannerImage = () => {
      return (
        props.data &&
        props.data.foodItem &&
        props.data.foodItem.banners &&
        props.data.foodItem.banners.length >= 1)
        ? props.data.foodItem.banners[0].image
        : null;
    };
    const getBannerLink = () => {
      return (
        props.data &&
        props.data.foodItem &&
        props.data.foodItem.banners &&
        props.data.foodItem.banners.length >= 1)
        ? props.data.foodItem.banners[0].link
        : null;
    };
    const clickBanner = () => {
      const link = getBannerLink();
      if (link != null && link != "") {
        context.emit("select-banner", link);
      }
    };
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("PantryPRFoodView onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("PantryPRFoodView onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };
    return {
      isShowImage,
      getImage,
      getName,
      getDescription,
      isShowBanner,
      getBannerImage,
      clickBanner,
      onImageError
    };
  }
});
